import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useCurrentUser } from "@/features/login/hooks/useCurrentUser";
import { ChevronDown, LogOut, KeyRound } from "lucide-react";
import { ThemeToggle } from "@/shared/components/ui/themeToggle";
import { useLogout } from "@/hooks/useLogout";
import gatoCool from "@/assets/gatoCool.png";
import { LogoClienteFinal } from "@/components/ui/LogoClienteFinal";
import { useState } from "react";
import { ChangePasswordDialog } from "@retro-ia/shared/password";

export function HeaderBranding() {
  const { usuarioInfo } = useCurrentUser();
  const { mutate: logout, isPending } = useLogout();
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);

  // Obtener colores de marca si existen
  const colorPrimario = usuarioInfo?.clienteFinal?.colorPrimario || "#1e293b";
  const colorSecundario =
    usuarioInfo?.clienteFinal?.colorSecundario || "#64748b";
  const headerBg = `linear-gradient(90deg, ${colorPrimario}, ${colorSecundario})`;

  return (
    <header
      className="w-full flex items-center justify-between px-6 py-4 border-b shadow-sm"
      style={{ background: headerBg }}
    >
      <div className="flex flex-col items-end gap-1">
        <LogoClienteFinal
          logoMarca={usuarioInfo?.clienteFinal?.logoMarca}
          defaultSrc={gatoCool}
          alt={(usuarioInfo?.clienteFinal?.nombreEmpresa ?? "Logo") + " logo"}
          className="h-12 w-auto mb-1 rounded shadow"
        />
      </div>
      <div className="flex items-center gap-10">
        <DropdownMenu>
          <DropdownMenuTrigger className="flex items-center gap-3 focus:outline-none">
            <Avatar>
              <AvatarFallback>
                {usuarioInfo?.nombre?.[0]}
                {usuarioInfo?.apellidoPaterno?.[0]}
              </AvatarFallback>
            </Avatar>
            <div className="hidden md:block text-left">
              <p className="text-sm font-medium text-foreground">
                {usuarioInfo?.nombre} {usuarioInfo?.apellidoPaterno}
              </p>
              <p className="text-xs text-muted-foreground">
                {usuarioInfo?.correo}
              </p>
            </div>
            <ChevronDown className="w-4 h-4 text-muted-foreground" />
          </DropdownMenuTrigger>

          <DropdownMenuContent
            align="end"
            className="w-56 bg-[var(--background)] border border-border shadow-md"
          >
            <DropdownMenuItem
              onClick={() => setChangePasswordOpen(true)}
              className="cursor-pointer hover:bg-[var(--muted)]"
            >
              <KeyRound className="w-4 h-4 mr-2" />
              Cambiar contraseña
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={() => logout()}
              disabled={isPending}
              className="cursor-pointer hover:bg-[var(--muted)]"
            >
              <LogOut className="w-4 h-4 mr-2" />
              {isPending ? "Cerrando..." : "Cerrar sesión"}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
        <ThemeToggle />
      </div>
      <ChangePasswordDialog
        open={changePasswordOpen}
        onOpenChange={setChangePasswordOpen}
      />
    </header>
  );
}
